import { createAction, props } from '@ngrx/store';

import { MetadataItemEntity } from '../components/metadata-list/metadata-item.entity';
import { MetadataListEntity } from '../components/metadata-list/metadata-list.entity';

export enum MetadataActions {
	InitMetadataList = '[Metadata] get metadata list',
	RefreshMetadataList = '[BE][Metadata] refresh metadata list',
	FetchMetadataListFail = '[BE][Metadata] fetch Metadata list fail',
	FetchMetadataListSuccess = '[BE][Metadata] fetch Metadata list success',
	NavigateToMetadataSource = '[Metadata] navigate to metadata source',
	NavigateToMetdataSourceSuccess = '[Metadata] navigate to metadata source success',
	NavigateToMetadataSourceFail = '[Metadata] navigate to metadata source fail',
}

export const initMetadataList = createAction(MetadataActions.InitMetadataList);

export const refreshMetadataList = createAction(
	MetadataActions.RefreshMetadataList
);

export const fetchMetadataListSuccess = createAction(
	MetadataActions.FetchMetadataListSuccess,
	props<{ metadataList: MetadataListEntity }>()
);

export const fetchMetadataListFail = createAction(
	MetadataActions.FetchMetadataListFail,
	props<{ error: unknown }>()
);

export const navigateToMetadataSource = createAction(
	MetadataActions.NavigateToMetadataSource,
	props<{ metadata: MetadataItemEntity }>()
);

export const navigateToMetdataSourceSuccess = createAction(
	MetadataActions.NavigateToMetdataSourceSuccess
);

export const navigateToMetadataSourceFail = createAction(
	MetadataActions.NavigateToMetadataSourceFail,
	props<{ error: unknown }>()
);
